/**
 * Created by swandelow on 9/29/16.
 */
angular.module('CarsSaraBo').directive('specialOfferCard', ['$translate', 'DateService','$location', function ($translate, dateService, $location) {
    return {
        scope: {
            offer: '=',
            remove: '&',
            clone: '&',
            moderate: '=',
            editable: '=editable',
            moderable: '=moderable',
            inCompanyContext: '='
        },

        link: function (scope) {
            scope.isCollapsed = true;
            scope.detailsLabel = 'common.VIEW_DETAIL';
            var textOverflowVerified = false;
            var hasTextOverflow = false;

            scope.getPointsOfSaleNames = function (offer) {
                var nameGenerator = function (pos) {
                    return pos.name;
                };

                return getNames(offer.pointsOfSale, offer.allPointsOfSaleSelected,'specialOffers.list.pointsOfSale.all', nameGenerator);
            };

            scope.getCarsNames = function (offer) {
                var nameGenerator = function (car) {
                    return car.carModel.brand + ' ' + car.carModel.model + ' - ' + car.name;
                };

                return getNames(offer.cars, offer.allCarsSelected,'specialOffers.list.cars.all', nameGenerator);
            };

            scope.getCarUpgradeName = function(offer) {
              var upgradeCar = offer.upgradeCar;

              return upgradeCar.carModel.brand + ' ' + upgradeCar.carModel.model + ' - ' + upgradeCar.name;
            };

            scope.getSiteNames = function (offer) {
                var nameGenerator = function (site) {
                    if(site.description !== 'OtherCountries'){
                        return site.description;
                    }
                    else{
                        return $translate.instant('specialOffers.site.' + site.description);
                    }

                };

                return getNames(offer.sites, offer.allSitesSelected, 'specialOffers.list.sites.all', nameGenerator);
            };

            scope.getChannelsName = function (offer) {
                var nameGenerator = function (channel) {
                    return $translate.instant('specialOffers.channel.' + channel);
                };

                return getNames(offer.channels, offer.allChannelsSelected, 'specialOffers.list.channels.all', nameGenerator);
            }

            function getNames(selectedItems, allSelectedFlag, allMessage, nameGenerator) {
                var nameList = [];
                
                if (allSelectedFlag) {
                    return $translate.instant(allMessage);
                }

                _.forEach(selectedItems, function (item) {
                    nameList.push(nameGenerator(item).toLowerCase());
                });

                return nameList.sort().join(', ');
            }

            scope.hasDetails = function (offer) {
                var hasBookingLengthInfo = offer.minBookedDays != undefined && offer.maxBookedDays != undefined;
                var hasBookingPeriod = offer.bookingWindow != undefined;

                if (!textOverflowVerified) {
                    var detailsArray = ['#carsDetails', '#posDetails', '#sitesDetails'];
                    hasTextOverflow = detailsArray.find((item) => {return verifyTextOverflow(offer, item)});

                    if (!!hasTextOverflow) {
                        textOverflowVerified = true;
                    }
                }

                return hasBookingLengthInfo || hasBookingPeriod || !!hasTextOverflow;
            };

            function verifyTextOverflow(offer, elementName) {
                var nameElem = elementName + offer.oid;
                var details = angular.element(document.querySelector(nameElem))[0];

                return details.offsetWidth < details.scrollWidth;
            }

            scope.toogleDetails = function () {
                scope.isCollapsed = !scope.isCollapsed;

                if($location.$$path.indexOf('/moderate') > -1){
                    scope.$parent.notifyGA(scope.isCollapsed?'Listado_moderación_ocultar_detalle':'Listado_moderación_ver_detalle', scope.offer);
                }

                if($location.$$path.indexOf('/specialoffer') > -1){
                    scope.$parent.notifyGA(scope.isCollapsed?'Listado_ocultar_detalle':'Listado_ver_detalle', scope.offer);
                }

                setDetailsLabel();
            };

            function setDetailsLabel() {
                scope.detailsLabel = (scope.isCollapsed) ? 'common.VIEW_DETAIL' : 'common.HIDE_DETAIL';
            }

            scope.getUpgradeFromCars =  function(offer) {
                return getCategoryParent(offer.cars[0]);
            };

            scope.getUpgradeCategory = function (offer) {
                return getCategoryParent(offer.upgradeCar);
            };

            function getCategoryParent(car){
                return car.carModel.categoryParent + ':';
            }

            scope.formatDate = function (dateString) {
                var pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;

                return dateString.replace(pattern, '$3/$2/$1');
            };

            scope.formatCreationDateTime = function(dateTimeString) {
                var date = new Date(dateTimeString);
                
                return dateService.customFormatDate(date, 'dd/MM/yyyy, HH:mm');
            }

        },

        templateUrl: 'assets/specialoffer/specialoffer-card.html'
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/specialoffer_card_directive.js
// module id = 887
// module chunks = 3